import type { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
  icon: LucideIcon;
  tone?: "default" | "ok" | "warning" | "error";
  loading?: boolean;
}

const TONES = {
  default: "bg-primary/12 text-primary",
  ok: "bg-state-ok/15 text-state-ok",
  warning: "bg-state-warning/20 text-state-warning",
  error: "bg-state-error/15 text-state-error",
} as const;

export function MetricCard({ label, value, hint, icon: Icon, tone = "default", loading }: MetricCardProps) {
  return (
    // `h-full` nos dois: numa grade, as celulas esticam ate a altura da mais
    // alta da linha, e sem isso o cartao mais curto ficava com o conteudo
    // grudado no topo e um vazio embaixo. Com a altura preenchida, o
    // `items-center` centra o conteudo na altura real do cartao, e o icone
    // deixa de ficar ancorado na primeira linha do texto.
    <Card className="h-full">
      <CardContent className="flex h-full items-center gap-3 p-4">
        <div className={cn("shrink-0 rounded-md p-2", TONES[tone])}>
          <Icon className="size-4" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-caption font-semibold uppercase tracking-wide text-muted-foreground">
            {label}
          </p>
          {loading ? (
            <Skeleton className="mt-1.5 h-7 w-24" />
          ) : (
            <p className="mt-0.5 truncate text-h5 font-black tracking-tight" title={value}>
              {value}
            </p>
          )}
          {hint ? <p className="mt-0.5 truncate text-caption text-muted-foreground">{hint}</p> : null}
        </div>
      </CardContent>
    </Card>
  );
}
